import React from "react";
import DatePicker from "react-datepicker";

import Row from "../../../../../components/Row";
import Col from "../../../../../components/Col";
import FontAwesomeIcon from "../../../../../components/Icon";

export const DateRangeFilters = ({ dates, setDates }) => (
  <Row style={{ marginBottom: "15px" }}>
    <Col md={6} xs={6}>
      <div className="filters-modal__label" style={{ marginTop: "15px" }}>
        Start Date
      </div>
      <div className="filters-modal-picker__datepicker">
        <div className="filters-modal-picker__chevron">
          <FontAwesomeIcon glyph="calendar" weight="light" />
        </div>
        <DatePicker
          selected={dates.startDate}
          onChange={(date) => {
            setDates({ ...dates, startDate: date });
          }}
          onFocus={(e) => (e.target.readOnly = true)}
          popperPlacement="top-start"
        />
      </div>
    </Col>
    <Col md={6} xs={6}>
      <div className="filters-modal__label" style={{ marginTop: "15px" }}>
        End Date
      </div>
      <div className="filters-modal-picker__datepicker">
        <div className="filters-modal-picker__chevron">
          <FontAwesomeIcon glyph="calendar" weight="light" />
        </div>
        <DatePicker
          selected={dates.endDate}
          onChange={(date) => {
            setDates({ ...dates, endDate: date });
          }}
          onFocus={(e) => (e.target.readOnly = true)}
          popperPlacement="top-start"
        />
      </div>
    </Col>
  </Row>
);
